import { IconButton, Tooltip } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

import { INTERNAL_ORDER_MATERIALS_TEXTS as TEXTS } from '../constants/internalOrdersConstants';

/**
 * Botón para desplegar u ocultar los materiales de un pedido técnico.
 * @param {Object} props
 * @param {boolean} props.expanded Si la fila está desplegada.
 * @param {Function} props.onClick Alterna el despliegue.
 * @returns {JSX.Element}
 */
const InternalOrderExpandButton = ({ expanded, onClick }) => (
  <Tooltip title={expanded ? TEXTS.collapse : TEXTS.expand}>
    <IconButton size="small" color="primary" aria-expanded={expanded} onClick={onClick}>
      {expanded ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
    </IconButton>
  </Tooltip>
);

export default InternalOrderExpandButton;
